import React from "react";
import { motion } from "framer-motion";

// 🎓 Education-related SVG icons with bright gradients
const icons = [
  { svg: <path d="M8 8h40a4 4 0 014 4v40a4 4 0 01-4 4H8V8zm4 4v36h32V12H12z" />, gradient: ["#3498db", "#9b59b6"] }, // Book
  { svg: <path d="M32 4L2 18l30 14 30-14L32 4zm0 22L10 16l22-10 22 10-22 10zm-8 10v10c0 4 4 6 8 6s8-2 8-6V36l-8 4-8-4z" />, gradient: ["#f39c12", "#e74c3c"] }, // Graduation cap
  { svg: <path d="M4 48l12 12 36-36-12-12L4 48zm40-40l12 12 4-4-12-12-4 4z" />, gradient: ["#f1c40f", "#e67e22"] }, // Pencil
  { svg: <path d="M4 44l36-36 16 16-36 36H4V44zm10 2h6v6h-6v-6z" />, gradient: ["#2ecc71", "#1abc9c"] }, // Ruler
  { svg: <path d="M8 56V24l24-12 24 12v32H8zm10-6h8v-8h-8v8zm20 0h8v-8h-8v8zM28 30h8v8h-8v-8z" />, gradient: ["#e67e22", "#f1c40f"] }, // School
  { svg: <path d="M12 8h40a4 4 0 014 4v40a4 4 0 01-4 4H12a4 4 0 01-4-4V12a4 4 0 014-4zm4 8h32v8H16v-8zm0 14h8v8h-8v-8zm0 12h8v8h-8v-8zm12-12h8v8h-8v-8zm12 0h8v8h-8v-8zm-12 12h8v8h-8v-8zm12 0h8v8h-8v-8z" />, gradient: ["#00b894", "#55efc4"] }, // Calculator
  { svg: <path d="M32 4a20 20 0 00-20 20c0 8 5 14 10 18v10h20V42c5-4 10-10 10-18A20 20 0 0032 4zm-6 48v4h12v-4H26zm0 6v2h12v-2H26z" />, gradient: ["#ffeaa7", "#f1c40f"] }, // Lightbulb
  { svg: <path d="M24 6c-6 0-10 5-10 10v4c-4 1-8 4-8 10s4 9 8 10v4c0 5 4 10 10 10s10-5 10-10V16c0-5-4-10-10-10zm16 0c6 0 10 5 10 10v4c4 1 8 4 8 10s-4 9-8 10v4c0 5-4 10-10 10s-10-5-10-10V16c0-5 4-10 10-10z" />, gradient: ["#ff7675", "#fd79a8"] }, // Brain
  { svg: <path d="M6 14h52v6H6v-6zm0 12h52v6H6v-6zm0 12h52v6H6v-6zm0 12h52v6H6v-6z" />, gradient: ["#6c5ce7", "#a29bfe"] }, // Books stack
  { svg: <path d="M32 4l30 12-30 12L2 16 32 4zm0 22l16-6v8c0 6-5 12-12 12s-12-6-12-12v-8l8 4zM20 44h24v16H20V44z" />, gradient: ["#1abc9c", "#16a085"] }, // Student
  { svg: <path d="M32 4a28 28 0 100 56c4 0 8-4 8-8 0-3-2-6-4-8h6a8 8 0 000-16h-4c2-2 4-5 4-8 0-4-4-8-8-8zm-8 12a4 4 0 11-4 4 4 4 0 014-4zm-6 12a4 4 0 11-4 4 4 4 0 014-4zm6 12a4 4 0 11-4 4 4 4 0 014-4zm12 0a4 4 0 11-4 4 4 4 0 014-4z" />, gradient: ["#e84393", "#fd79a8"] }, // Palette
  { svg: <path d="M32 4a28 28 0 1028 28A28 28 0 0032 4zm0 50a22 22 0 1122-22 22 22 0 01-22 22z" />, gradient: ["#2980b9", "#6dd5fa"] }, // Circle globe
  { svg: <path d="M8 8h48v8H8zm0 12h48v8H8zm0 12h48v8H8zm0 12h48v8H8z" />, gradient: ["#9b59b6", "#8e44ad"] }, // Notepad lines
  { svg: <path d="M16 8h32v8H16zm0 12h32v8H16zm0 12h32v8H16z" />, gradient: ["#27ae60", "#2ecc71"] }, // Whiteboard
  { svg: <path d="M6 10h52v44H6V10zm8 8v28h36V18H14z" />, gradient: ["#f39c12", "#d35400"] }, // Screen
  { svg: <path d="M12 16h40v8H12zm0 12h40v8H12zm0 12h40v8H12z" />, gradient: ["#c0392b", "#e74c3c"] }, // Chalkboard
  { svg: <path d="M8 12h48v40H8z" />, gradient: ["#16a085", "#1abc9c"] }, // Monitor
  { svg: <path d="M8 52l24-40 24 40H8z" />, gradient: ["#f1c40f", "#f39c12"] }, // Triangle (geometry)
  { svg: <path d="M32 6l24 52H8L32 6z" />, gradient: ["#8e44ad", "#9b59b6"] }, // Compass
  { svg: <path d="M12 8h40v48H12z" />, gradient: ["#00cec9", "#0984e3"] }, // Document
  { svg: <path d="M6 16h52v32H6z" />, gradient: ["#6c5ce7", "#a29bfe"] }, // Blackboard
  { svg: <path d="M16 8h32v48H16z" />, gradient: ["#e84393", "#fd79a8"] }, // Tablet
];

// 🪶 Medium floating animation
const floatMedium = {
  y: [0, -10, 0],
  transition: { duration: 6, repeat: Infinity, ease: "easeInOut" },
};

export default function ParticleBackground() {
  // 🎯 Balanced placement — top, sides, bottom
  const positions = [
    // Top
    { top: "6%", left: "10%" },
    { top: "8%", left: "35%" },
    { top: "5%", right: "20%" },
    { top: "10%", right: "8%" },

    // Left side
    { top: "20%", left: "5%" },
    { top: "40%", left: "8%" },
    { top: "60%", left: "4%" },
    { bottom: "12%", left: "10%" },

    // Right side
    { top: "25%", right: "5%" },
    { top: "45%", right: "8%" },
    { top: "65%", right: "5%" },
    { bottom: "14%", right: "12%" },

    // Bottom center
    { bottom: "8%", left: "25%" },
    { bottom: "6%", left: "40%" },
    { bottom: "10%", left: "55%" },
    { bottom: "6%", left: "70%" },
  ];

  return (
    <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
      {positions.map((pos, i) => {
        const { svg, gradient } = icons[i % icons.length];
        const size = 50 + Math.random() * 40;
        const rotate = Math.random() * 20 - 10;
        const opacity = 0.8;

        return (
          <motion.div
            key={i}
            style={{
              position: "absolute",
              ...pos,
              width: size,
              height: size,
              transform: `rotate(${rotate}deg)`,
              opacity,
            }}
            animate={floatMedium}
          >
            <svg viewBox="0 0 64 64" width={size} height={size}>
              <defs>
                <linearGradient id={`grad-${i}`} x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor={gradient[0]} />
                  <stop offset="100%" stopColor={gradient[1]} />
                </linearGradient>
              </defs>
              {React.cloneElement(svg, { fill: `url(#grad-${i})` })}
            </svg>
          </motion.div>
        );
      })}
    </div>
  );
}
